import { TimeIcon } from '@fourthwall/icons'
import React, { useState } from 'react'
import { Input } from '../../inputs/Input'
import * as S from './Calendar.styled'
import { useTime } from './hooks/useTime'

type CalendarTimeInputProps = {
  value: string
  label?: string
  isValid: boolean
  onValueChange: (value: string) => void
}

export const CalendarTimeInput = ({
  value,
  label,
  isValid,
  onValueChange,
}: CalendarTimeInputProps) => {
  const [isFocused, setIsFocused] = useState(false)
  const { format } = useTime()
  const formattedValue = format(value)

  const handleValueChange = (newValue: string) => {
    onValueChange(format(newValue.toUpperCase()))
  }

  const renderMaskCharacters = (mask: string) => {
    return mask.split('').map((letter, index) => (
      <S.TimeInputMaskLetter key={index} $hidden={index < formattedValue.length}>
        {index < formattedValue.length ? formattedValue[index] : letter}
      </S.TimeInputMaskLetter>
    ))
  }

  return (
    <S.TimeInputContainer>
      <Input
        label={label}
        size="medium"
        value={formattedValue}
        error={!isValid && !isFocused}
        displayError={false}
        leftIcon={TimeIcon}
        onValueChange={handleValueChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      />
      {isFocused && <S.TimeInputMask>{renderMaskCharacters('HH:MM AM')}</S.TimeInputMask>}
    </S.TimeInputContainer>
  )
}
